<template>
    <AppLayout
        ref="layout"
        page="/dashboard"
        pageTitle="Studio Health"
        backLink="/dashboard/reports"
        :showFooter="editing"
        @save="$refs.table.save()"
        @cancel="$refs.table.cancel()"
    >
        <StudioHealthChart v-if="chartData.length" :chartData="chartData" />
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        ref="reportHeader"
                        :allLocations="allLocations"
                        locationOptions
                        :selectedLocation="selectedLocation"
                        :updated="meta.updated_at"
                        subtitle="Monthly Studio KPIs, earnings, and expenses"
                        filter
                        :filterData="!!(compareMonth || compareYear)"
                        hideSearch
                        monthSelector
                        :dateRange="dateRange"
                        @reset="editing = false"
                        reportUrl="/dashboard/reports/studio-health/"
                        dateOptions="month, year, quarter"
                        ><template #filterItem>
                            <v-list-item>
                                <CompareMonth
                                    :value="compareMonth"
                                    :disabled="!!compareYear || allLocations"
                                    :date="dateRange[0]"
                                    @input="
                                        $refs.reportHeader.updateRange({
                                            rangeStart: dateRange[0],
                                            rangeEnd: dateRange[1],
                                            ...$event,
                                        })
                                    "
                                    @clear="
                                        $refs.reportHeader.updateRange({
                                            rangeStart: dateRange[0],
                                            rangeEnd: dateRange[1],
                                            ...$event,
                                        })
                                    "
                                />
                            </v-list-item>
                            <v-list-item>
                                <v-btn
                                    :href="`/exports/studio-health/${$page.props.selectedLocation.id}?rangeStart=${dateRange[0]}&rangeEnd=${dateRange[1]}`"
                                    text
                                    outlined
                                    rounded
                                    block
                                    color="dark"
                                    :disabled="
                                        !!compareMonth ||
                                        allLocations ||
                                        !meta?.id
                                    "
                                    >Download as CSV<v-icon small right
                                        >download</v-icon
                                    ></v-btn
                                >
                            </v-list-item>
                        </template>
                    </ReportHeader>
                    <div>
                        <StudioHealthTable
                            ref="table"
                            :columnOrder="columnOrder"
                            :categoryOrder="categoryOrder"
                            :headers="headers"
                            :items="studioHealth"
                            :meta="meta"
                            :userEntry="
                                !!(
                                    !allLocations &&
                                    !compareMonth &&
                                    !compareYear &&
                                    meta?.date
                                )
                            "
                            @editing="editing = $event"
                            @success="$refs.layout.showMessage = true"
                            :key="meta.id"
                        />
                    </div>
                </v-container>
            </v-card>
        </v-col>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import StudioHealthTable from "../../Components/Reports/StudioHealthTable.vue";
import CompareMonth from "../../Components/Reports/CompareMonth.vue";
import CompareYear from "../../Components/Reports/CompareYear.vue";
import DateRange from "../../Components/Reports/DateRange.vue";
import StudioHealthChart from "../../Components/Reports/StudioHealthChart.vue";

export default {
    props: {
        studioHealth: {
            type: Array,
            default: () => [],
        },
        categoryOrder: {
            type: Array,
            default: () => [],
        },
        columnOrder: {
            type: Array,
            default: () => [],
        },
        headers: {
            type: Array,
            default: () => [],
        },
        meta: {
            type: Object,
            default: () => {},
        },
        selectedLocation: {
            type: Object,
            default: null,
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
        compareMonth: {
            type: String,
            default: null,
        },
        compareYear: {
            type: String,
            default: null,
        },
        chartData: {
            type: Array,
            default: () => [],
        },
    },
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
        ReportHeader,
        StudioHealthTable,
        CompareMonth,
        CompareYear,
        DateRange,
        StudioHealthChart,
    },
    data() {
        return {
            search: "",
            editing: false,
        };
    },
};
</script>
